/* Display-only converter using daily reference rates. Shopify checkout stays in shop.currency. */
(() => {
  const options = [...document.querySelectorAll('[data-ax-currency-code]')];
  if (!options.length) return;

  const base = document.querySelector('[data-ax-currency]')?.dataset.axBaseCurrency || document.documentElement.dataset.axBaseCurrency || 'USD';
  const currencies = [...new Set(options.map(option => option.dataset.axCurrencyCode))];
  const targets = currencies.filter(currency => currency !== base);
  let rates = { [base]: 1 };
  let selected = base;

  try {
    const saved = localStorage.getItem('ax-display-currency');
    if (saved && currencies.includes(saved)) selected = saved;
  } catch (_) {}

  const format = (amount, currency) => new Intl.NumberFormat(navigator.language || 'en', {
    style: 'currency',
    currency
  }).format(amount);

  const updatePrices = () => {
    const rate = rates[selected];
    document.querySelectorAll('[data-ax-price][data-ax-cents]').forEach(node => {
      if (node.dataset.axRenderedCents !== node.dataset.axCents) {
        node.dataset.axOriginal = node.textContent.trim();
        node.dataset.axRenderedCents = node.dataset.axCents;
      } else if (!node.dataset.axOriginal) {
        node.dataset.axOriginal = node.textContent.trim();
      }
      const amount = Number(node.dataset.axCents) / 100;
      const sourceCurrency = node.dataset.axBase || base;
      const sourceRate = rates[sourceCurrency];
      if (selected === base || !Number.isFinite(amount) || !rate || !sourceRate) {
        if (node.textContent !== node.dataset.axOriginal) node.textContent = node.dataset.axOriginal;
        return;
      }
      const converted = format(amount / sourceRate * rate, selected);
      if (node.textContent !== converted) node.textContent = converted;
    });

    document.querySelectorAll('[data-ax-currency]').forEach(root => {
      const trigger = root.querySelector('[data-ax-current-currency]');
      if (trigger && trigger.textContent !== selected) trigger.textContent = selected;
      root.querySelectorAll('[data-ax-currency-code]').forEach(option => {
        option.setAttribute('aria-selected', String(option.dataset.axCurrencyCode === selected));
      });
      const status = root.querySelector('[data-ax-rate-status]');
      const nextStatus = selected === base
        ? 'Store currency selected.'
        : rates[selected] ? 'Reference rates updated daily.'
          : 'This currency rate is unavailable right now.';
      if (status && status.textContent !== nextStatus) status.textContent = nextStatus;
    });

    document.querySelectorAll('[data-ax-converter-notice]').forEach(notice => {
      notice.hidden = selected === base;
      const currency = notice.querySelector('[data-ax-notice-currency]');
      if (currency && currency.textContent !== selected) currency.textContent = selected;
    });
  };

  document.addEventListener('ax:currency-change', event => {
    if (!currencies.includes(event.detail?.currency)) return;
    selected = rates[event.detail.currency] ? event.detail.currency : base;
    updatePrices();
  });

  const loadRates = async () => {
    if (!targets.length) { updatePrices(); return; }
    try {
      const url = 'https://api.frankfurter.dev/v2/rates?base=' + encodeURIComponent(base) + '&quotes=' + encodeURIComponent(targets.join(','));
      const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-cache' });
      if (!response.ok) throw new Error('Exchange rates unavailable');
      const rows = await response.json();
      rows.forEach(row => {
        if (row.base === base && currencies.includes(row.quote) && Number.isFinite(Number(row.rate))) {
          rates[row.quote] = Number(row.rate);
        }
      });
    } catch (_) {
      // Keep the shop currency visible if the reference-rate service is unreachable.
    }

    document.querySelectorAll('[data-ax-currency-code]').forEach(option => {
      option.disabled = !rates[option.dataset.axCurrencyCode];
    });
    if (!rates[selected]) {
      selected = base;
      try { localStorage.setItem('ax-display-currency', base); } catch (_) {}
    }
    updatePrices();
  };

  const applyToNewPrices = new MutationObserver(records => {
    const hasNewPriceMarkup = records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return !target?.closest('[data-ax-price]');
    });
    if (hasNewPriceMarkup) updatePrices();
  });
  if (document.body) applyToNewPrices.observe(document.body, { childList: true, subtree: true });

  updatePrices();
  loadRates();
})();
